import { getAPIHeaders } from '../config/api';

export async function submitFeedback(payload) {
  const response = await fetch('/api/feedback', {
    method: 'POST',
    headers: getAPIHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.detail || data.error || 'Failed to submit feedback.';
    throw new Error(message);
  }

  return data;
}
